import { render, staticRenderFns } from "./post-edit-name.vue?vue&type=template&id=b041bea0"
import script from "./post-edit-name.vue?vue&type=script&lang=js"
export * from "./post-edit-name.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports